export default "__VITE_ASSET__$6UtFC$ggZWao0xraMGF_A__";